import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import commonCss from './CreativeAsset.css';

const VideoAsset = ({
    url,
    ref,
    onLoad: onLoadProp,
    onError: onErrorProp,
    controls = false,
    showCreativeTypeIndication = false,
    muted = true,
}) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [remainingVideoDuration, setRemainingVideoDuration] = useState(null);

    const handleVideo = () => {
        if (controls || !ref?.current) return;

        setIsPlaying(prevIsPlaying => !prevIsPlaying);
        if (isPlaying) {
            ref.current.pause();
            ref.current.currentTime = 0; // go back to the beginning of the video
        } else {
            ref.current.play();
        }
    };

    const onError = async () => {
        if (!controls) {
            setIsPlaying(false);
        }
        onErrorProp && onErrorProp();
    };

    const onVideoUpdate = () => {
        if (showCreativeTypeIndication && ref?.current) {
            const { duration, currentTime } = ref.current;
            if (!duration) {
                return;
            }
            const remainingDuration = duration - currentTime;

            const totalSeconds = Math.round(remainingDuration);

            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            const formattedSeconds = `${seconds}`.padStart(2, '0');

            setRemainingVideoDuration(`${minutes}:${formattedSeconds}`);
        }
    };

    const onLoad = () => {
        onVideoUpdate();
        onLoadProp && onLoadProp();
    };

    useEffect(() => {
        onVideoUpdate();
    }, [showCreativeTypeIndication]);

    return (
        <>
            {remainingVideoDuration && showCreativeTypeIndication && (
                <div className={commonCss.creativeType}>{remainingVideoDuration}</div>
            )}
            <video
                ref={ref}
                data-testid={`video_${url}`}
                className={commonCss.creativeAsset}
                onLoadedData={onLoad}
                onError={onError}
                muted={muted}
                loop
                onPointerOver={handleVideo}
                onPointerLeave={handleVideo}
                onTimeUpdate={onVideoUpdate}
                controls={controls}
            >
                <track kind="captions" />
                <source src={url} type="video/mp4" />
            </video>
        </>
    );
};

VideoAsset.propTypes = {
    ref: PropTypes.shape({ current: Element }),
    url: PropTypes.string,
    onLoad: PropTypes.func,
    onError: PropTypes.func,
    controls: PropTypes.bool,
    showCreativeTypeIndication: PropTypes.bool,
    muted: PropTypes.bool,
};

export default VideoAsset;
